export default __webpack_public_path__ + "static/media/warning-circle.2020b211.svg";